<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                Review Supplier Invoice
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-indigo-300">Review the details in the supplier invoice below</p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="space-y-6 pt-6 pb-5">
                                                <div>
                                                    
                                                </div>
                                                <div>
                                                    <label for="fixture" class="block text-sm text-gray-900 required">
                                                        Fixture
                                                    </label>
                                                    <div class="mt-1">
                                                        <vue-select v-model="form.fixture_id" label="title" :options="fixtures" :reduce="fixtures => fixtures.id"></vue-select>                                                        
                                                    </div>
                                                    <div class="mt-2 text-sm text-gray-900">
                                                        If you change the fixture the supplier invoice is assigned to then finance will be notified.
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="amount" class="block text-sm text-gray-900 required">
                                                        Amount ({{ amount_currency_code }})
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="amount" v-model="form.amount"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{'border-red-500': form.errors.amout}"
                                                        />
                                                    </div>
                                                    <div class="mt-2 text-sm text-gray-900">
                                                        If you change the amount of the supplier invoice then finance will be notified. This amount will then be marked as disputed until approved.
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="additional-information" class="block text-sm text-gray-900">
                                                        Additional Email Content
                                                    </label>
                                                    <div class="mt-1">
                                                        <quill-editor
                                                            content-type="html"
                                                            v-model:content="form.additional_information"
                                                            class="min-h-[150px] block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                            theme="snow">
                                                        </quill-editor>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="supporting_documents" class="block text-sm text-gray-900">
                                                        Supporting Documents
                                                    </label>
                                                    <label class="w-full mb-4 mt-1 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide uppercase border border-blue cursor-pointer">
                                                        <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                            <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                                        </svg>
                                                        <span v-if="form.file_uploads.length  === 0" class="mt-2 text-base leading-normal">Select a file</span>
                                                        <span v-else>{{ form.file_uploads.length }} file<span v-if="form.file_uploads.length > 1">s</span> selected for upload</span>
                                                        <input type='file' class="hidden" multiple @change="prepareFileUpload($event)" />
                                                    </label>
                                                </div>
                                                <div>
                                                    <div class="mt-1 text-sm text-gray-900">
                                                        <strong>Notes</strong>
                                                    </div>
                                                    <div class="mt-1 text-sm text-gray-900" v-html="supplier_notes">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span>Mark as Reviewed</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive, computed} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {
  LinkIcon,
  PlusSmIcon,
  QuestionMarkCircleIcon,
  ExclamationCircleIcon,
  ArrowCircleRightIcon,
  RefreshIcon
} from '@heroicons/vue/solid'
import {useForm, usePage} from '@inertiajs/vue3'
import { router } from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors";
import {mapState, mapActions} from 'vuex'
import {pickBy} from "lodash";
import {emitter} from "@/eventHub";
import VueSelect from "vue-select";

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        ArrowCircleRightIcon,
        RefreshIcon,
        VueSelect
    },
    computed: {
        ...mapState({
            fixtures: state => state.fixtures.all ?? null
        })
    },
    data() {
        return {
            show: ref(false),
            showErrors: ref(false),
            form: useForm({
                id: null,
                fixture_id: null,
                amount: null,
                additional_information: null,
                file_uploads: [],
            }),
            supplier_notes: null,
            amount_currency_code: 'GBP'
        }
    },
    mounted() {
        emitter.on('openReviewInvoice', (supplier_invoice) => {
            this.getAllFixtures();
            this.form.id = supplier_invoice.id;
            this.form.fixture_id = supplier_invoice.fixture_id;
            this.form.amount = supplier_invoice.amount;
            this.supplier_notes = supplier_invoice.notes;
            this.amount_currency_code = supplier_invoice.currency?.code ?? 'GBP';
            this.open();
        });        
    },
    methods: {
        getAllFixtures() {
            this.$store.dispatch('fixtures/getAll')
        },
        overrideClient() {
          this.clientOverride = true
        },
        revertToFixtureClient() {
            this.clientOverride = false
            this.form.client_id = this.fixture.client.id
        },
        submit() {
            this.form.post(route('frontend.supplier-invoices.review'), {
                onSuccess: page => {
                    this.show = false;
                    this.showErrors = false;
                    this.form.reset();
                },
                onError: errors => {
                    this.showErrors = true;
                }
            });            
        },
        close() {
            this.form.reset();
            this.form.clearErrors();
            this.amount_currency_code = 'GBP';
            this.show = false;
        },
        open() {
            this.form.clearErrors();
            this.show = true;
        },
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        },
    }
}
</script>
